import { GLOBAL_CHANGE_PAGE, GLOBAL_NAVIGATE, GLOBAL_LOGOUT_START, GLOBAL_LOGIN_SUCCESS, GLOBAL_LOAD_GRIDS, GLOBAL_LOGOUT_END, LoginSuccessAction, ChangePageAction, NavigateAction, AuthEndpoints, OAuthToken, Response, GlobalLoadGridsAction } from './types'
import { takeEvery, fork, all, put, select, call } from 'redux-saga/effects'
import { httpGet, httpPost, ApiResponse } from 'src/api'
import { SagaIterator } from 'redux-saga'
import { doLogoutFinish, addSnackbar, changePage, setGrids } from './actions'
import { GetToken, GetBaseUrl, GetLocation } from './selectors'
import { Location } from 'history';
import { Dictionary } from 'lodash';
import { GridEntity, Response as ListResponse } from '../query/types'
import { ROUTEHOME } from 'src/domains/global/routes'
import { push } from "redux-first-history";


function* startWatchers(): SagaIterator {
    yield takeEvery(GLOBAL_CHANGE_PAGE, changePageWorker)
    yield takeEvery(GLOBAL_NAVIGATE, navigateWorker)
    yield takeEvery(GLOBAL_LOGOUT_START, logoutWorker)
    yield takeEvery(GLOBAL_LOGOUT_END, logoutEndWorker)
    yield takeEvery(GLOBAL_LOGIN_SUCCESS, loginWorker)
    yield takeEvery(GLOBAL_LOAD_GRIDS, loadGridsWorker)
}

function* loginWorker(payload: LoginSuccessAction) {
}

function* logoutWorker() {
    let base: string = yield select(GetBaseUrl)
    let token: OAuthToken = yield select(GetToken)

    let endpoint = `${base}${AuthEndpoints.Logout}`

    try {
        yield call(logoutPost, endpoint, token)
    } catch {
    }

    yield put(doLogoutFinish());
    yield put(addSnackbar('Logout successful!', 'logoutSuccess', {}));
}

function* logoutEndWorker() {
    yield put(changePage(ROUTEHOME));
}

function* loadGridsWorker(payload: GlobalLoadGridsAction) {
    const { resourceNames } = payload;

    const params: any = {
        attributes: '_id,name,resource,attributes,filter,order',
        filter: resourceNames.map(name => `(resource eq "${name}")`).join(' or '),
    }

    let url = `/query/_grid/.search`;

    try {
        let response: ApiResponse = yield call(httpPost, url, {}, {}, params);
        if (response.status == 200) {
            const grids: Dictionary<Dictionary<GridEntity>> = {};
            (response.json.tuples as any[]).forEach(tuple => {
                const resource = tuple['resource'];
                let resourceGrids = grids[resource];
                if (resourceGrids == null) {
                    resourceGrids = {};
                    grids[resource] = resourceGrids;
                }
                const grid: GridEntity = {
                    id: tuple['_id'],
                    name: tuple['name'],
                    resource: tuple['resource'],
                    attributes: tuple['attributes'],
                    filter: tuple['filter'],
                    order: tuple['order'],
                }
                resourceGrids[tuple['_id']] = grid;
            });
            yield put(setGrids(grids));
        } else {
            // yield put(setError(response.json));
        }
    } catch (err: any) {
        // yield put(setError(err));
    }
}

function* changePageWorker(payload: ChangePageAction) {
    const { route, search } = payload;
    yield put(push({ pathname: route, search }))
}

function* navigateWorker(payload: NavigateAction) {
    const location: Location = yield select(GetLocation);
    const { route } = payload;
    const currentRoute = location.pathname;
    let goToRoute = route;

    if (!route.startsWith('/')) {
        const currentTokens = currentRoute.split('/');
        const tokens = route.split('/');
        const resultTokens = tokens.reduce((acc, token, index) => {
            if (token === '..') {
                acc.pop();
            } else {
                acc.push(token);
            }
            return acc;
        }, currentTokens);
        goToRoute = resultTokens.join('/');
    }

    yield put(changePage(goToRoute));
}

export default function* StartGlobalSagas() {
    yield all([fork(startWatchers)]);
}

const logoutPost = async (endpoint: string, token: OAuthToken) => {
    let options: RequestInit = {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
            'Authorization': `${token?.token_type} ${token?.access_token}`,
            'Content-Type': 'application/json'
        }
    }

    await fetch(endpoint, options)
}
